const CustomFormIds = {
  ADD_LOAN: "ADD_LOAN",
  ADD_BORROWER: "ADD_BORROWER",
  ADD_PAYMENT_DETAILS: "ADD_PAYMENT_DETAILS",
  EXPOSURE_GROUP: "EXPOSURE_GROUP",
};

export default CustomFormIds;
